import { AppType } from '@repo/types';
import { $api } from './base';

export const getFrontendVersion = (
  appType?: AppType,
): Promise<{ appVersion: string }> => {
  return $api
    .get('api/core/frontend-version', {
      params: {
        appType,
      },
    })
    .then((response) => response.data);
};
